module.exports = __webpack_public_path__ + "static/media/33.29e8ec4c.jpg";